module.exports = {
  serverUrl:  'https://api.yssolutions.in'  ,
    phoneNumber : '+918089579470' ,
    locationUrl : "https://maps.app.goo.gl/6WbcB5RDKYAywEFP9",
    address:"Y's TechSolutions, Madathumpady, Thrissur, Kerala 680733",
    mail:"info@yssolutions.in"
  }